import { FC } from 'react';

type UserMessageProps = {
  content: string;
};

const UserMessage: FC<UserMessageProps> = ({ content }) => (
  <div className="navi-user-message">
    <div className="navi-user-message__bubble">{content}</div>
  </div>
);

export default UserMessage;
